/**
 * Mellfy Memory Section 03 Custom - Enhanced Color Selection
 * カスタムコレクショングリッド - カラー選択機能強化
 * 元のテーマのカラー選択機能と互換性を持つ実装
 * 干渉防止のための独自クラス名を使用
 */

document.addEventListener("DOMContentLoaded", function () {
  // カラー選択機能の初期化
  initCustomColorSelection();

  // 商品画像の動的切り替え機能
  initCustomProductImageSwitching();

  // モバイル用スワイプ機能の初期化
  initMobileSwipeFunctionality();

  // デバッグ情報の表示
  setTimeout(debugCustomColorData, 1000);
});

/**
 * カスタムカラー選択機能の初期化
 * 独自のクラス名を使用して干渉を防ぐ
 */
function initCustomColorSelection() {
  const colorContainers = document.querySelectorAll(".mm-sec03-custom-colors");

  colorContainers.forEach(function (container) {
    const colorItems = container.querySelectorAll(
      ".mm-sec03-custom-color-item"
    );
    const productWrapper = container.closest(".mm-sec03-custom-wrapper");
    const productElement = container.closest(".mm-sec03-custom-product");

    console.log("🔍 カスタムカラーコンテナを検出:", {
      container: container,
      colorItems: colorItems.length,
      productWrapper: !!productWrapper,
      productElement: !!productElement,
    });

    colorItems.forEach(function (colorItem) {
      // クリックイベント
      colorItem.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const colorValue = this.getAttribute("data-color");
        const colorDisplayValue =
          this.getAttribute("data-color-value") || colorValue;

        console.log("🎨 カスタムカラーアイテムがクリックされました:", {
          colorValue: colorValue,
          colorDisplayValue: colorDisplayValue,
          productWrapper: !!productWrapper,
        });

        if (productWrapper && productElement) {
          // アクティブなカラーを更新
          updateCustomActiveColor(productWrapper, this);

          // 商品画像を切り替え
          switchCustomProductImageByColor(
            productWrapper,
            colorValue,
            colorDisplayValue,
            container
          );
        } else {
          console.warn("⚠️ カスタム商品ラッパーまたは商品要素が見つかりません");
        }
      });

      // ホバーイベント
      colorItem.addEventListener("mouseenter", function () {
        const colorValue = this.getAttribute("data-color");
        const colorDisplayValue =
          this.getAttribute("data-color-value") || colorValue;

        if (productWrapper) {
          // ホバー時の画像切り替え
          switchCustomProductImageByColor(
            productWrapper,
            colorValue,
            colorDisplayValue,
            container,
            true // ホバーモード
          );
        }
      });

      colorItem.addEventListener("mouseleave", function () {
        if (productWrapper) {
          // ホバー終了時に元の画像に戻す
          restoreCustomOriginalImage(productWrapper);
        }
      });
    });
  });
}

/**
 * カスタムアクティブなカラーの更新
 */
function updateCustomActiveColor(productWrapper, activeColorItem) {
  // 同じ商品内の他のカラーアイテムからアクティブクラスを削除
  const allColorItems = productWrapper.querySelectorAll(
    ".mm-sec03-custom-color-item"
  );
  allColorItems.forEach(function (item) {
    item.classList.remove("mm-sec03-custom-color-item--active");
  });

  // クリックされたカラーアイテムにアクティブクラスを追加
  activeColorItem.classList.add("mm-sec03-custom-color-item--active");
}

/**
 * カスタムカラーに基づく商品画像の切り替え
 * 元のテーマのdata-color-optionsデータを使用
 */
function switchCustomProductImageByColor(
  productWrapper,
  colorValue,
  colorDisplayValue,
  colorContainer,
  isHover = false
) {
  const productImg = productWrapper.querySelector(".mm-sec03-custom-main-img");
  if (!productImg || !colorContainer) return;

  // data-color-optionsからデータを取得
  const colorOptionsData = colorContainer.getAttribute("data-color-options");

  if (!colorOptionsData) {
    console.warn("⚠️ カスタムdata-color-optionsが見つかりません");
    return;
  }

  try {
    const colorData = JSON.parse(colorOptionsData);
    console.log("🔍 カスタムカラーデータ:", colorData);

    const { color_variants, img_variants, color_variants_handle, img_options } =
      colorData;

    if (!color_variants || !img_variants || !color_variants_handle) {
      console.warn("⚠️ 必要なカスタムカラーデータが不足しています");
      return;
    }

    // カラーのインデックスを取得
    let colorIndex = -1;
    for (let i = 0; i < color_variants_handle.length; i++) {
      if (color_variants_handle[i] === colorValue) {
        colorIndex = i;
        break;
      }
    }

    console.log("🎯 カスタムカラーインデックス検索結果:", {
      colorValue: colorValue,
      colorIndex: colorIndex,
      color_variants_handle: color_variants_handle,
    });

    if (colorIndex === -1) {
      console.warn("⚠️ 選択されたカスタムカラーのデータが見つかりません:", {
        colorValue: colorValue,
        availableHandles: color_variants_handle,
      });
      return;
    }

    // 新しい画像URLを取得
    const newImageUrl = img_variants[colorIndex];

    if (!newImageUrl) {
      console.warn("カスタムカラーに対応する画像が見つかりません:", colorValue);
      return;
    }

    // ホバーモードの場合は元の画像を保存
    if (isHover && !productWrapper.dataset.originalImage) {
      productWrapper.dataset.originalImage = productImg.src;
    }

    // 画像の切り替えアニメーション
    productImg.style.opacity = "0.5";
    productImg.style.transition = "opacity 0.3s ease";

    // 画像の読み込みを待ってから表示
    const tempImg = new Image();
    tempImg.onload = function () {
      productImg.src = newImageUrl;
      productImg.style.opacity = "1";
    };
    tempImg.onerror = function () {
      console.warn("カスタム画像の読み込みに失敗しました:", newImageUrl);
      productImg.style.opacity = "1";
    };
    tempImg.src = newImageUrl;
  } catch (error) {
    console.error("カスタムカラーデータの解析に失敗しました:", error);
  }
}

/**
 * カスタム元の画像に戻す（ホバー終了時）
 */
function restoreCustomOriginalImage(productWrapper) {
  const productImg = productWrapper.querySelector(".mm-sec03-custom-main-img");
  const originalImage = productWrapper.dataset.originalImage;

  if (productImg && originalImage) {
    productImg.style.opacity = "0.5";
    productImg.style.transition = "opacity 0.3s ease";

    setTimeout(() => {
      productImg.src = originalImage;
      productImg.style.opacity = "1";
      delete productWrapper.dataset.originalImage;
    }, 150);
  }
}

/**
 * カスタム商品URLの更新（オプション）
 */
function updateCustomProductUrl(productWrapper, colorValue, colorDisplayValue) {
  const productLink = productWrapper.querySelector("a[data-pr-href]");

  if (productLink) {
    const currentUrl = productLink.href;
    const baseUrl = currentUrl.split("?")[0];

    // カラーバリエーションのパラメータを追加
    const newUrl =
      baseUrl + "?variant=" + encodeURIComponent(colorDisplayValue);

    // リンクのhref属性を更新
    productLink.setAttribute("href", newUrl);
  }
}

/**
 * カスタム商品画像の動的切り替え機能の初期化
 */
function initCustomProductImageSwitching() {
  const productWrappers = document.querySelectorAll(".mm-sec03-custom-wrapper");

  productWrappers.forEach(function (wrapper) {
    const productImg = wrapper.querySelector(".mm-sec03-custom-main-img");

    if (productImg) {
      // 画像の読み込み完了時の処理
      productImg.addEventListener("load", function () {
        this.style.opacity = "1";
      });

      // 画像の読み込みエラー時の処理
      productImg.addEventListener("error", function () {
        console.warn("カスタム商品画像の読み込みに失敗しました:", this.src);
        this.style.opacity = "0.5";
      });
    }
  });
}

/**
 * カスタムカラーバリエーションのデータを取得する関数
 * コメント: この関数は実際の商品データに基づいて実装する必要があります
 */
function getCustomColorVariants(productId) {
  // コメント: 実際の実装では、商品のバリエーションデータを取得
  // 例: Shopifyの商品APIを使用してバリエーションデータを取得

  return {
    // 例: カラーバリエーションのデータ構造
    variants: [
      {
        color: "red",
        image: "/products/product-red.jpg",
        variantId: "123456789",
      },
      {
        color: "blue",
        image: "/products/product-blue.jpg",
        variantId: "123456790",
      },
    ],
  };
}

/**
 * カスタムレスポンシブ対応のカラー表示調整
 */
function adjustCustomColorDisplayForResponsive() {
  const colorContainers = document.querySelectorAll(".mm-sec03-custom-colors");

  colorContainers.forEach(function (container) {
    const colorItems = container.querySelectorAll(
      ".mm-sec03-custom-color-item"
    );

    // モバイル表示時の調整
    if (window.innerWidth <= 768) {
      colorItems.forEach(function (item) {
        const colorValue = item.querySelector(".mm-sec03-custom-color-value");
        if (colorValue) {
          colorValue.style.width = "16px";
          colorValue.style.height = "16px";
        }
      });
    } else {
      // デスクトップ表示時の調整
      colorItems.forEach(function (item) {
        const colorValue = item.querySelector(".mm-sec03-custom-color-value");
        if (colorValue) {
          colorValue.style.width = "20px";
          colorValue.style.height = "20px";
        }
      });
    }
  });
}

// ウィンドウリサイズ時の処理
window.addEventListener("resize", function () {
  adjustCustomColorDisplayForResponsive();
});

// 初期化時のレスポンシブ調整
adjustCustomColorDisplayForResponsive();

/**
 * カスタムデバッグ用: カラーデータの確認
 * 新しいdata-color-options構造に対応
 */
function debugCustomColorData() {
  const colorContainers = document.querySelectorAll(".mm-sec03-custom-colors");

  console.log("=== カスタムカラーバリエーションデバッグ情報 ===");
  console.log("検出されたカスタムカラーコンテナ数:", colorContainers.length);

  if (colorContainers.length === 0) {
    console.warn("⚠️ カスタムカラーバリエーションコンテナが見つかりません");
    console.log("商品にカラーバリエーションが設定されているか確認してください");
    return;
  }

  colorContainers.forEach(function (container, index) {
    console.log(`\n--- カスタム商品 ${index + 1} ---`);

    const colorOptionsData = container.getAttribute("data-color-options");
    console.log("カスタムdata-color-options:", colorOptionsData);

    if (colorOptionsData) {
      try {
        const colorData = JSON.parse(colorOptionsData);
        console.log("🔍 解析されたカスタムカラーデータ:", colorData);

        console.log("  - color_count:", colorData.color_count);
        console.log("  - color_variants:", colorData.color_variants);
        console.log(
          "  - color_variants_handle:",
          colorData.color_variants_handle
        );
        console.log("  - img_variants:", colorData.img_variants);
        console.log("  - id_variants:", colorData.id_variants);
        console.log("  - img_options:", colorData.img_options);

        if (colorData.colors_swatch) {
          console.log("  - colors_swatch:", colorData.colors_swatch);
        }
        if (colorData.images_swatch) {
          console.log("  - images_swatch:", colorData.images_swatch);
        }
      } catch (error) {
        console.error("カスタムカラーデータの解析に失敗:", error);
      }
    }

    // カラーアイテムの確認
    const colorItems = container.querySelectorAll(
      ".mm-sec03-custom-color-item"
    );
    console.log("カスタムカラーアイテム数:", colorItems.length);

    colorItems.forEach(function (item, itemIndex) {
      console.log(`  カスタムカラー ${itemIndex + 1}:`, {
        color: item.getAttribute("data-color"),
        value: item.getAttribute("data-color-value"),
        title: item.getAttribute("title"),
        hasValue: !!item.querySelector(".mm-sec03-custom-color-value"),
        valueElement: item.querySelector(".mm-sec03-custom-color-value"),
      });
    });
  });

  console.log("\n=== カスタムデバッグ情報終了 ===");
}

/**
 * カスタム商品リンクの処理
 * 商品ページへのリンクを確実にする
 */
function initCustomProductLinks() {
  const productLinks = document.querySelectorAll(".mm-sec03-custom-link");

  productLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      // 商品ページへのリンクを確実にする
      const productUrl = this.getAttribute("href");
      if (productUrl && productUrl !== "#") {
        // リンクが有効な場合はそのまま進む
        console.log("カスタム商品リンク:", productUrl);
      } else {
        // 無効なリンクの場合はデフォルトの商品ページにリダイレクト
        e.preventDefault();
        console.warn("無効なカスタム商品リンクが検出されました");
      }
    });
  });
}

// カスタム商品リンクの初期化
document.addEventListener("DOMContentLoaded", function () {
  initCustomProductLinks();
});

/**
 * モバイル用スワイプ機能の初期化
 * 横スクロール可能なグリッドレイアウトでのスワイプ操作を実装
 */
function initMobileSwipeFunctionality() {
  const containers = document.querySelectorAll(".mm-sec03-custom-cards-container");
  if (!containers.length) return;

  const mq = window.matchMedia("(max-width: 768px)");

  function resetScrollToStart(container) {
    container.scrollLeft = 0;
    requestAnimationFrame(function () {
      container.scrollLeft = 0;
    });
    setTimeout(function () {
      container.scrollLeft = 0;
    }, 120);
  }

  function applyNativeSwipe(container, isMobile) {
    if (isMobile) {
      container.style.webkitOverflowScrolling = "touch";
      container.style.overscrollBehaviorX = "contain";
      container.style.touchAction = "pan-x";
      container.style.scrollBehavior = "smooth";
      resetScrollToStart(container);
    } else {
      container.style.webkitOverflowScrolling = "";
      container.style.overscrollBehaviorX = "";
      container.style.touchAction = "";
      container.style.scrollBehavior = "";
    }
  }

  containers.forEach(function (container) {
    applyNativeSwipe(container, mq.matches);
  });

  const handleChange = function (e) {
    containers.forEach(function (container) {
      applyNativeSwipe(container, e.matches);
    });
  };

  if (typeof mq.addEventListener === "function") {
    mq.addEventListener("change", handleChange);
  } else if (typeof mq.addListener === "function") {
    mq.addListener(handleChange);
  }
}

// デバッグ用（開発時のみ有効）
if (
  window.location.hostname === "localhost" ||
  window.location.hostname.includes("myshopify.com")
) {
  // 3秒後にデバッグ情報を表示
  setTimeout(debugCustomColorData, 3000);
}
